/* eslint-disable */
import React, { useEffect } from "react";
import { getBankIntegrations } from "../../../actions/appExpandedActions/finances";
import { connect } from "react-redux";
import DataTable from "../DataTable";
import { tablePresets } from "../DataTable/tablePresets";

const BankIntegrations = ({ getBankIntegrations, bankIntegrations, period }) => {
  // Initial load
  useEffect(() => {
    getBankIntegrations({ page: 1, limit: 20 });
  }, []);

  // Handle period changes - support both new PeriodSelector and legacy formats
  useEffect(() => {
    // For "All time" (both null), send empty strings
    if (!period?.startDate && !period?.endDate) {
      getBankIntegrations({
        page: 1,
        limit: 20,
        startDate: "",
        endDate: ""
      });
    } else if (period?.startDate) {
      // For specific periods, send the actual dates
      getBankIntegrations({
        page: 1,
        limit: 20,
        startDate: period?.startDate || "",
        endDate: period?.endDate || "",
      });
    }
  }, [period]);

  const handleLoadMore = (page) => {
    // Use the same logic for load more
    const payload = {
      page,
      limit: 20
    };
    
    if (!period?.startDate && !period?.endDate) {
      payload.startDate = "";
      payload.endDate = "";
    } else if (period?.startDate) {
      payload.startDate = period?.startDate || "";
      payload.endDate = period?.endDate || "";
    }
    
    getBankIntegrations(payload);
  };

  return (
    <DataTable
      {...tablePresets.bankIntegrations}
      data={bankIntegrations}
      fetchData={getBankIntegrations}
      period={period}
      onLoadMore={handleLoadMore}
    />
  );
};

const mapStateToProps = (state) => ({
  bankIntegrations: state.appFinances.bankIntegrations,
});

const mapDispatchToProps = (dispatch) => ({
  getBankIntegrations: (payload) => dispatch(getBankIntegrations(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BankIntegrations);